import Container from '@amzn/awsui-components-react/polaris/container';
import Form from '@amzn/awsui-components-react/polaris/form';
import Header from '@amzn/awsui-components-react/polaris/header';
import { FormikField, InputField } from '@amzn/event-engine-js-utils';
import React from 'react';

import {
    FormSchemaType,
    Step,
    StepValidator,
} from './../../JoinEvent.validation';

export const isStepOneValid: StepValidator = async (
    formik
): Promise<boolean> => {
    try {
        const validatedFormErrors = await formik.validateForm(formik.values);
        return !validatedFormErrors[Step.ACCESS_CODE_STEP_ONE];
    } catch (e) {
        return false;
    }
};

export const generateFormFieldPrefix = (
    str: keyof FormSchemaType[Step.ACCESS_CODE_STEP_ONE]
) => {
    return `${[
        Step.ACCESS_CODE_STEP_ONE,
    ]}.${str}` as keyof FormSchemaType[Step.ACCESS_CODE_STEP_ONE];
};

interface EventAccessCodeProps {
    isValidating?: boolean;
}

const EventAccessCode = ({ isValidating }: EventAccessCodeProps) => {
    return (
        <Form>
            <Container header={<Header variant="h2">Event access code</Header>}>
                <FormikField<FormSchemaType[Step.ACCESS_CODE_STEP_ONE]>
                    name={generateFormFieldPrefix('accessCode')}
                    dataTestId="accessCode"
                    formFieldProps={{
                        label: 'Event access code',
                        description:
                            'A 12 digit code that was given to you for this event',
                        stretch: true,
                        children: (
                            <InputField<
                                FormSchemaType[Step.ACCESS_CODE_STEP_ONE]
                            >
                                name={generateFormFieldPrefix('accessCode')}
                                placeholder={'abcd-012345-ef'}
                                inputProps={{
                                    type: 'text',
                                    disabled: isValidating,
                                    spellcheck: false,
                                }}
                            />
                        ),
                    }}
                />
            </Container>
        </Form>
    );
};

export default EventAccessCode;
